<div class="report-container office-inventory">
    <!-- Menu -->
    <app-report-sub-menu [menuList]="overViewMenu" (menuChangeValue)="menuChangeValue($event)"></app-report-sub-menu>
    <!-- Overview -->
    <div class="report-tabsection" id="{{ officeInventoryMenuEnum.overview}}"
        [ngClass]="{ 'scroll': currentScroll === officeInventoryMenuEnum.overview}">
        <ng-container *ngIf="overviewLoading">
            <app-skeleton-loader [reportType]="chartView.overView" [height]="'150px'"></app-skeleton-loader>
        </ng-container>
        <div class="report-overview  report-overview-3col" *ngIf="!overviewLoading">
            <!-- Total Properties -->
            <app-overview-card [card_title]="'reports.Estater_Tracked_Properties'" [total_current]="overviewData?.total_properties"
                [untillDate]="overviewData?.untillDate" [developerText]="overviewData?.developed_properties"
                [underConstructionText]="overviewData?.under_construction_properties"
                [showDeveloped]="true"></app-overview-card>
            <!-- Existing Inventory (sqm) -->
            <app-overview-card [card_title]="'reports.existingInventory'"
                [total_current]="overviewData?.existing_inventory" [untillDate]="overviewData?.untillDate"
                [uniType]="UnitTypeEnum.sqm"></app-overview-card>
            <!-- Supply - Under Construction pipeline (sqm) -->
            <app-overview-card [card_title]="'reports.supplyUnderConstructionPipeline'"
                [total_current]="captiveOfficeData?.captive_office_share"
                [total_current]="overviewData?.supply_under_construction" [untillDate]="overviewData?.untillDate"
                [uniType]="UnitTypeEnum.sqm"></app-overview-card>
        </div>
        <!-- Gross Open Market Office Space - Grade Wise (sqm) Graph -->
        <div class="report-model report-rentrate">
            <div class="report-model-header">
                <div class="info">
                    <h3>{{'reports.gross_open_market_office_space' | translate}} ({{'reports.sqm_unit' |
                            translate}})
                    </h3>
                </div>
                <button class="btn-select-grade" [matMenuTriggerFor]="menu"
                    *ngIf="!overviewGraphLoading && ((retailRentalChartReport | json) != '{}' && (retailRentalChartReport | json) != '[]')">
                    <div class="setext">
                        <ng-container *ngFor="let name of selectedChartValue; let l = last">{{name}}<span *ngIf="!l"
                                style="padding-right: 2px;">,</span></ng-container>
                    </div>
                    <span class="morecount" *ngIf="selectedChartValue.length > 1">{{moreText}}</span>
                    <mat-icon>keyboard_arrow_down</mat-icon>
                </button>

                <mat-menu #menu="matMenu" [xPosition]="langName === 'ar' ? 'after' : 'before'"
                    class="grades-menu directionLtr">
                    <div (click)="$event.stopPropagation()">
                        <h5>{{'reports.choose_maximum_options' | translate}}</h5>
                        <ng-container *ngFor="let category of getReportKeys()">
                            <mat-checkbox (change)="selectChart($event, category)"
                                [checked]="selectedChartValue.includes(category)">{{category}}</mat-checkbox>
                        </ng-container>
                    </div>
                </mat-menu>
            </div>
            <ng-container *ngIf="overviewGraphLoading">
                <app-skeleton-loader [reportType]="chartView.barChart"></app-skeleton-loader>
            </ng-container>
            <ng-container *ngIf="!overviewGraphLoading">

                <ng-container
                    *ngTemplateOutlet="(retailRentalChartReport | json) != '{}' && (retailRentalChartReport | json) != '[]' ? retailRentalChart : noChartData"></ng-container>

                <ng-template #retailRentalChart>
                    <div class="multiBarChart d-flex">
                        <!-- {{retailRentalChartReport.length}} -->
                        <ng-container *ngFor="let chart of retailRentalChartReportArray; let i = index">
                            <ng-container *ngFor="let key of getKeys(chart)">
                                <app-report-charts class="grchart" [data]="chart[key]" [chartType]="chartView.smallBarChart" [isBorder]="false"
                                    [name]="key" [index]="i"
                                    [ngStyle]="{'min-width': (retailRentalChartReportArray | keyvalue).length == 1 ? '100%' : '300px'}">
                                </app-report-charts>
                            </ng-container>
                        </ng-container>
                    </div>
                </ng-template>
            </ng-container>
        </div>
        <!-- Year Wise Supply - Incremental (sqm) -->
        <div class="app-waterfall-chart">
            <div class="report-model report-rentrate">
                <div class="report-model-header">
                    <div class="info">
                        <h3>{{'reports.yearWiseSupplyIncremental' | translate}} ({{'reports.sqm_unit' |
                            translate}})
                        </h3>
                    </div>
                    <button class="btn-select-grade" [matMenuTriggerFor]="menu1"
                        *ngIf="!supplyChartLoading && (overviewWaterfallChart | json) != '[]'">
                        <div class="setext">
                            {{yearWiseSelectedGrade['value']}}
                        </div>
                        <mat-icon>keyboard_arrow_down</mat-icon>
                    </button>

                    <mat-menu #menu1="matMenu" [xPosition]="langName === 'ar' ? 'after' : 'before'"
                        class="grades-menu directionLtr">
                        <div (click)="$event.stopPropagation()">
                            <h5>{{'reports.pleaseSelectOneOption' | translate}}</h5>
                            <mat-radio-group aria-label="Select an option" [formControl]="yearWiseSelectedGrade"
                                (change)="gradeSelect($event)">
                                <mat-radio-button [value]="grade"
                                    *ngFor="let grade of supplyIncrementalDropdown">{{grade}}</mat-radio-button>
                            </mat-radio-group>
                        </div>
                    </mat-menu>
                </div>
                <ng-container *ngIf="supplyChartLoading">
                    <app-skeleton-loader [reportType]="chartView.barChart"></app-skeleton-loader>
                </ng-container>
                <ng-container *ngIf="!supplyChartLoading">
                    <ng-container
                        *ngTemplateOutlet="(overviewWaterfallChart | json) != '[]' ? supplyChart : noChartData"></ng-container>
                    <ng-template #supplyChart>
                        <app-waterfall-chart class="directionLtr" [data]="overviewWaterfallChart"
                            [label]="yearWiseSelectedGrade['value']"></app-waterfall-chart>
                    </ng-template>
                </ng-container>
            </div>
        </div>
    </div>
    <!-- Neighborhood Table -->
    <div class="report-tabsection" [ngClass]="{ 'scroll': currentScroll === officeInventoryMenuEnum.neighborhood}"
        id="{{ officeInventoryMenuEnum.neighborhood }}">
        <app-report-year-dropdown [reportType]="'neighborhood'"
            (selectedYear)="selectedYear($event)"></app-report-year-dropdown>
        <div class="report-model">

            <app-datatable-title [title]="'reports.neighborhood'" [count]="neighborhoodCount"></app-datatable-title>

            <app-office-inventory-neighborhood [showLoader]="!neighborhoodLoading" [tableColumns]="neighborhoodColumns" [dataLength]="neighborhoodCount" [tableData]="neighborhoodData" (pageEvent)="onPageEvent($event, officeInventoryMenuEnum.neighborhood)"
                (excelDownload)="downloadExcel($event, 'office_inventory_neighborhood_v2', 'a')" [downloadLoading]="downloadLoading['a']" [dropDownOption]="propertyTypeDropdown" (dropDownValue)="dropDownChange($event)"></app-office-inventory-neighborhood>

        </div>
    </div>
    <!-- Properties -->
    <div class="report-tabsection" [ngClass]="{ 'scroll': currentScroll === officeInventoryMenuEnum.properties}"
        id="{{ officeInventoryMenuEnum.properties }}">
        <app-report-year-dropdown [reportType]="'transaction'"
            (selectedYear)="selectedYear($event)"></app-report-year-dropdown>
        <div class="report-model">

            <app-datatable-title [title]="'reports.projectsProperties'" [count]="propertiesCount"></app-datatable-title>

            <app-office-inventory-properties [showLoader]="!propertiesLoading"
                [tableColumns]="propertiesColumns" [dataLength]="propertiesCount" [tableData]="propertiesTableData"
                (pageEvent)="onPageEvent($event, officeInventoryMenuEnum.properties)"
                (sort)="sortData($event, officeInventoryMenuEnum.properties)"
                (excelDownload)="downloadExcel($event, 'office_inventory_properties', 'b')"
                [downloadLoading]="downloadLoading['b']">
            </app-office-inventory-properties>
        </div>
    </div>
</div>

<!-- Common Chart No Data -->
<ng-template #noChartData>
    <div class="data_unavail">
        <span>
            {{"reports.data_not_available" | translate}} <mat-icon role="img"
                class="mat-icon notranslate material-icons mat-ligature-font mat-icon-no-color" aria-hidden="true"
                data-mat-icon-type="font">equalizer</mat-icon>
        </span>
    </div>
</ng-template>
